import React from 'react';
import 'yuki-createjs';
import { connect } from 'react-redux';
import { charInc, charClear } from '../../../actions/char';
import Char from '../shared/Char';
import CharBtn from '../shared/CharBtn';
import RestartBtn from '../shared/RestartBtn';
import GuidelinesOnBtn from '../shared/GuidelinesOnBtn';
import GuidelinesOffBtn from '../shared/GuidelinesOffBtn';
import { setSpacing, setOwnSpacing } from '../../../utils/utils';

export class OwnTrack extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            char: undefined,
            charCase: 'lc',
            charClearState: false,
            total: 0,
            array: [],
            isPlaying: false,
            guidelinesShown: true
        };

        createjs.Ticker.on('tick', this.tick, this);
        createjs.Ticker.framerate = 30;
    }
    load() {
        this.props.charInc();

        this.state.loader = new createjs.LoadQueue(true);
        this.state.loader.on('complete', this.create, this);

        this.state.manifest = [{ 
            src: 'images/sections/' + this.state.charCase + '/chars/track/' + this.state.char + '.json', 
            id: 'own-track-spritesheet',
            type: 'spritesheet'
        }];

        while (this.state.manifest.length > 0) {
            this.state.loader.loadFile(this.state.manifest.shift());
        }
    }
    create() {
        let _this = this,
            idx = this.state.array.length,
            cvs = document.getElementById('lc-track-cvs-' + idx),
            btn = $('.char-btn', '#own-track');

        this.state.array[idx] = new Object();
        this.state.array[idx].canvas = cvs;
        this.state.array[idx].stage = new createjs.Stage(this.state.array[idx].canvas);
        this.state.array[idx].anim = new createjs.Sprite(this.state.loader.getResult('own-track-spritesheet'));
        this.state.array[idx].anim.id = idx;
        this.state.array[idx].char = this.state.char;
        this.state.array[idx].spacing = setOwnSpacing(this.state.char, this.state.charCase);
        this.state.array[idx].btn = btn.eq(idx);
        this.state.array[idx].btnSpacing = setSpacing(this.state.char, this.state.charCase);

        this.state.array[idx].stage.addChild(this.state.array[idx].anim);
        this.state.array[idx].anim.on('animationend', this.end, this);

        this.state.array[idx].btn.on('touchstart mousedown', function() {

            let id = parseInt($(this).attr('id'));

            _this.state.array[id].anim.play();

            $('body').on('touchend mouseup', function() {

                _this.state.array[id].anim.stop();

                $('body').off('touchend mouseup');
            });
        });

        $(window).on('resize.own-track', function() {
            _this.resize();
        });

        this.resize();
    }
    end(e) {
        e.target.gotoAndPlay('active');
    }
    tick() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.array.length; i++) {
                if (this.state.array[i].stage !== undefined) {
                    this.state.array[i].stage.update();
                }
            }
        }
    }
    pos() {
        const holder = $('.holder-inner', '#own-track'),
            holderBaseW = 598,
            holderBaseH = 104;
        let char = $('.char-holder', '#own-track'),
            charBtn = $('.char-btn', '#own-track'),
            holderW = holder.width(),
            holderH = holder.height(),
            holderPercW = holderW / 100,
            holderPercH = holderH / 100,
            spaceW,
            spaceT,
            spaceH,
            btnBaseW,
            btnTop,
            btnTopPerc,
            btnTopOffsetPerc,
            btnW,
            btnH,
            xPosStart = 15,
            xPos = xPosStart,
            xInc,
            letter,
            spacingX = 5;

        for (let i = 0; i < this.state.array.length; i++) {

            letter = this.state.array[i].char;

            if (xPos !== xPosStart) {
                if (letter === 'j') {
                    //xPos -= holderPercW * (((16*0.8)/holderBaseW) * 100);
                } else if (letter === 'g') {
                    xPos -= holderPercW * (((6*0.8)/holderBaseW) * 100)
                }
            }

            spaceW = ((this.state.array[i].spacing[1] + spacingX)*0.8);
            xInc = holderPercW * ((spaceW/holderBaseW) * 100);

            char.eq(i).css('left', xPos + 'px');

            if (letter !== 'space') {

                spaceT = this.state.array[i].btnSpacing[2] * 0.8;
                spaceH = this.state.array[i].btnSpacing[4] * 0.8;
                btnTopPerc = (spaceT/holderBaseH) * 100;
                btnTopOffsetPerc = (6 / holderBaseH) * 100;
                btnTop = (holderPercH * btnTopPerc) - (btnTopOffsetPerc * holderPercH);
                btnBaseW = (this.state.array[i].btnSpacing[3] + 4) * 0.8;
                btnW = holderPercW * ((btnBaseW/holderBaseW) * 100);
                btnH = holderPercH * ((spaceH/holderBaseH) * 100);

                charBtn.eq(i).css({
                    'top': btnTop + 'px',
                    'left': xPos + 'px',
                    'width': btnW + 'px',
                    'height': btnH + 'px'
                });
            }

            xPos += xInc;
        }
    }
    resize() {
        const parent = $('.char-holder'),
            curr = $('.lc-track-cvs');
        let parentW = parent.width(),
            parentH = parent.height(),
            currW = curr.width(),
            currH = curr.height(),
            scale = parentH / 300;

        curr.attr('height', $('#own-track').height() - $('.holder', '#own-track').position().top);
        
        for (var i = 0; i < this.state.array.length; i++) {
            this.state.array[i].stage.scaleX = scale;
            this.state.array[i].stage.scaleY = scale;
        }

        this.pos();
    }
    clear() {
        if (this.state.charClearState) {
            this.setState({ 
                total: 0,
                array: [],
                charClearState: false
            });
            this.props.charClear(false);
        }
    }
    play() {
        this.stop();
        if (this.state.array.length) {
            this.state.array[0].anim.gotoAndPlay('active');
        }
        this.setState({ isPlaying: true });
    }
    stop() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].anim.gotoAndStop('active');
            }
        }
        this.setState({ isPlaying: false });
    }
    guidelinesShow() {
        $('.guidelines', '#own-track').show();
        this.setState({ guidelinesShown: true });
    }
    guidelinesHide() {
        $('.guidelines', '#own-track').hide();
        this.setState({ guidelinesShown: false });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.char) {
            this.setState({ 
                char: nextProps.char,
                charCase: nextProps.charCase,
                total: this.state.total + 1
            });
        }
        if (nextProps.charClearState) {
            this.setState({ 
                charClearState: nextProps.charClearState
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ((prevState.total !== this.state.total) && (this.state.total !== 0)) {
            this.load();
        }
        if (prevState.charClearState !== this.state.charClearState) {
            this.clear();
        }
    }
    componentWillUnmount() {
        $(window).off('resize.own-track');
    }
    render() {
        return (
            <div id="own-track" className="panel">
                <div className="title"></div>
                <div className="guidelines-txt"></div>
                <GuidelinesOffBtn onClick={this.guidelinesHide.bind(this)} selected={!this.state.guidelinesShown} />
                <GuidelinesOnBtn onClick={this.guidelinesShow.bind(this)} selected={this.state.guidelinesShown} />
                <RestartBtn onClick={this.stop.bind(this)} />
                <div className="holder">
                    <div className="holder-inner">
                        {[...Array(this.state.total)].map((label, index) => {
                            return (
                                <CharBtn key={index} id={index} />
                            );
                        })}
                        {[...Array(this.state.total)].map((label, index) => {
                            return (
                                <Char key={index} id={index} charType="lc" animType="track" />
                            );
                        })}
                    </div>
                    <div className="guidelines"></div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        char: state.char.char,
        charCase: state.char.charCase,
        charClearState: state.char.charClearState
    };
}

const mapDispatchToProps = (dispatch) => ({
    charInc: () => dispatch(charInc()),
    charClear: (charClearState) => dispatch(charClear(charClearState))
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnTrack);



// WEBPACK FOOTER //
// ./src/components/sections/own/OwnTrack.js